export type DistanceTier = { upToKm: number; ratePerKm: number };

export type RuleSet = {
  currency: string;
  returnDiscountPercent: number; // applies on round-trip
  visibility: {
    // passenger-count based visibility; infants excluded externally
    // arrays hold allowed vehicle keys to show
    ranges: Array<{ min: number; max: number; vehicles: VehicleKey[] }>
  };
  pricing: {
    shuttle: {
      perPerson: true;
      minPrice: number;
      includedKm: number;
      extraPerKmAfterIncluded: number;
    };
    vito: {
      perVehicle: true;
      tiers: DistanceTier[]; // progressive
      extraFeeByPassengers: { [pax: number]: number }; // 5->5€,6->6€...
      basePassengersForLowCounts: number; // use 4 pax base for 1–3 pax
    };
    sprinter: {
      perVehicle: true;
      minPrice: number;
      includedKm: number;
      extraPerKmAfterIncluded: number;
    };
  };
};

export type VehicleKey = "shuttle" | "vito" | "sprinter";

export const DEFAULT_RULES: RuleSet = {
  currency: "EUR",
  returnDiscountPercent: 5,
  visibility: {
    ranges: [
      { min: 1, max: 2, vehicles: ["shuttle", "vito"] },
      { min: 3, max: 3, vehicles: ["shuttle", "vito"] }, // aligns with later pricing rule using 4 pax base
      { min: 4, max: 4, vehicles: ["vito"] },
      { min: 5, max: 7, vehicles: ["vito", "sprinter"] },
      { min: 8, max: 12, vehicles: ["sprinter"] },
    ],
  },
  pricing: {
    shuttle: {
      perPerson: true,
      minPrice: 15,
      includedKm: 20,
      extraPerKmAfterIncluded: 0.35,
    },
    vito: {
      perVehicle: true,
      tiers: [
        { upToKm: 30, ratePerKm: 1 },
        { upToKm: 60, ratePerKm: 0.9 },
        { upToKm: 120, ratePerKm: 0.8 },
      ],
      extraFeeByPassengers: { 5: 5, 6: 6, 7: 7 },
      basePassengersForLowCounts: 4,
    },
    sprinter: {
      perVehicle: true,
      minPrice: 50,
      includedKm: 20,
      extraPerKmAfterIncluded: 1.8,
    },
  },
};

const KEY = "transfer_rules";

export function loadRules(): RuleSet {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return DEFAULT_RULES;
    return { ...DEFAULT_RULES, ...JSON.parse(raw) } as RuleSet;
  } catch {
    return DEFAULT_RULES;
  }
}

export function saveRules(rules: RuleSet) {
  localStorage.setItem(KEY, JSON.stringify(rules));
}
